import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PerformanceReviewQuestionService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('PerformanceReviewQuestion');
	}
	
	loadAll() : Observable<ePM.Logic.PerformanceReviewQuestion[]> {
		return this.myBaseService.loadAll(this.url);
	}
	getForReview(id: System.Guid): Observable<ePM.Logic.PerformanceReviewQuestion[]> {
		return this.myBaseService.get(id, this.url);
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.PerformanceReviewQuestion> {
		return this.myBaseService.save(tempItem, this.url);
	}
	
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.PerformanceReviewQuestion> {
		return this.myBaseService.getEdit(id, this.url);
	}
}			